const saveDataToast = {
    button: 'ZAPISZ',
    header: 'Ostrzeżenie',
    body: 'Nie zapomnij zapisać zmian!',
};

export default saveDataToast;